import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LandingFooter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="landing-footer">
      <div className="landing-footer-inner">
        <div className="landing-footer-about">
          <p>{t("landingFooter.description")}</p>
        </div>
        <div className="landing-footer-links">
          <div className="landing-footer-col">
            <h4>{t("landingFooter.exploreSulhafa.title")}</h4>
            <button className="footer-link-btn" onClick={() => navigate("/sulhafa-connect")}>
              {t("landingFooter.exploreSulhafa.sulhafaConnect")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/sulhafa-care")}>
              {t("landingFooter.exploreSulhafa.sulhafaCare")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/sulhafa-care")}>
              {t("landingFooter.exploreSulhafa.sulhafaShop")}
            </button>
          </div>
          <div className="landing-footer-col">
            <h4>{t("landingFooter.support.title")}</h4>
            <button className="footer-link-btn" onClick={() => navigate("/privacy")}>
              {t("landingFooter.support.privacyPolicy")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/terms")}>
              {t("landingFooter.support.termsConditions")}
            </button>
            <button className="footer-link-btn" onClick={() => navigate("/contact")}>
              {t("landingFooter.support.contactUs")}
            </button>
          </div>
        </div>
        <div className="landing-footer-subscribe">
          <h4>{t("landingFooter.stayConnected.title")}</h4>
          <p>{t("landingFooter.stayConnected.description")}</p>
          <div className="landing-subscribe-form">
            <input type="email" placeholder={t("landingFooter.stayConnected.emailPlaceholder")} />
            <button>{t("landingFooter.stayConnected.subscribe")}</button>
          </div>
        </div>
      </div>
      <div className="landing-footer-bottom">
        <img src="/Landing page assets/Sulhafa_Logo_White.png" alt="Sulhafa" className="landing-footer-logo" />
        <p className="landing-footer-powered">{t("landingFooter.exploreSulhafa.PoweredbyRubix")}</p>
      </div>
    </footer>
  );
};

export default LandingFooter;
